import React, { useContext, useEffect, useRef } from "react";

//Custom Components
import MapContext from "@/components/Map/MapContext";

//OL
import OlBaseLayer from "ol/layer/Base";
import OlSourceVector from "ol/source/Vector";

//Types
import { MapContextType } from "@/@types/context/MapContext";
import VectorLayer from "./VectorLayer";
import { Geometry } from "ol/geom";
import { StyleLike } from "ol/style/Style";
import { IVectorLayer } from "@/@types/components/Map/Layers";



function ClientLayer(props: IVectorLayer) {
  const { id, source, style } = props;
  const mapContext = useContext<MapContextType | null>(MapContext);

  const checkIfLayerVisible = () => {
    const visibility = mapContext?.getLayerVisibility();
    const hiddenLayers = visibility ? Object.keys(visibility).filter((key) => visibility[key] === false) : [];
    // console.log(hiddenLayers);

    const isVisible = hiddenLayers.indexOf(id) >= 0 ? false : true;
    return isVisible;
  };

  const visible = checkIfLayerVisible();

  return (
    <VectorLayer {...props} visible={visible}/>
  );
}

export default ClientLayer;
